import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-pixverse-color-large.tsx
/**
* icon.24.logo.pixverse.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTEwLjg0NCAyMC44NzcgNi4zNDYgMTguNzZWNy4xNzVjMC0uNTUuMjQtMS4xNi42My0xLjU0OWwxLjA0LTEuMDQgNC41NDcgMTQuNzk3Yy4zMiAxLjAzMy0uNzQgMS45NTQtMS43MTkgMS40OTQiLz48cGF0aCBmaWxsPSJ1cmwoI2IpIiBkPSJtMTcuMTE2IDkuMzIyLTUuMTMyLTUuNjQ0YTIuMDc0IDIuMDc0IDAgMCAwLTMtLjA3bC0yLjAwOCAyLjAyYy0uMzg0LjQzOC0uNjAzLjg5OC0uNjAzIDEuNDQ3VjE4LjY2bDEwLjI3NS02LjE2NGEyLjA3MyAyLjA3MyAwIDAgMCAuNDY3LTMuMTczIi8+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iLTEuODI1IiB4Mj0iMTIuNDg1IiB5MT0iNy4xNDYiIHkyPSIyMC44MzQiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjRkU5RTU4Ii8+PHN0b3Agb2Zmc2V0PSIuMzk2IiBzdG9wLWNvbG9yPSIjRTQ3MEVDIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDQyRkJBIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImIiIHgxPSIxNC41NDQiIHgyPSIuMjM0IiB5MT0iNy4wNDciIHkyPSIyMC43MzUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjRkZBMDUyIi8+PHN0b3Agb2Zmc2V0PSIuMzk2IiBzdG9wLWNvbG9yPSIjRTM2Q0ZBIiBzdG9wLW9wYWNpdHk9Ii44Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDQyRkJBIiBzdG9wLW9wYWNpdHk9Ii43Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-12605
*/
const Icon24LogoPixverseColorLarge = memo(function Icon24LogoPixverseColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "M10.844 20.877 6.346 18.76V7.175c0-.55.24-1.16.63-1.549l1.04-1.04 4.547 14.797c.32 1.033-.74 1.954-1.719 1.494"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "m17.116 9.322-5.132-5.644a2.074 2.074 0 0 0-3-.07l-2.008 2.02c-.384.438-.603.898-.603 1.447V18.66l10.275-6.164a2.073 2.073 0 0 0 .467-3.173"
			}),
			/* @__PURE__ */ jsxs("defs", { children: [/* @__PURE__ */ jsxs("linearGradient", {
				id: ida,
				x1: "-1.825",
				x2: "12.485",
				y1: "7.146",
				y2: "20.834",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ jsx("stop", { stopColor: "#FE9E58" }),
					/* @__PURE__ */ jsx("stop", {
						offset: ".396",
						stopColor: "#E470EC"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#442FBA"
					})
				]
			}), /* @__PURE__ */ jsxs("linearGradient", {
				id: idb,
				x1: "14.544",
				x2: ".234",
				y1: "7.047",
				y2: "20.735",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ jsx("stop", { stopColor: "#FFA052" }),
					/* @__PURE__ */ jsx("stop", {
						offset: ".396",
						stopColor: "#E36CFA",
						stopOpacity: ".8"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#442FBA",
						stopOpacity: ".7"
					})
				]
			})] })
		]
	});
});
//#endregion
export { Icon24LogoPixverseColorLarge };

//# sourceMappingURL=icon-24-logo-pixverse-color-large.js.map